import Axios from "../util/axiosInstance";

export const GetTalentLegalDocument = () => {
    return Axios.get(`/api/LegalDocuments/GetTalentLegalDocuments`)
}

export const viewTalentLegalDocument = (docType, dateSigned) => {
    return Axios.get(`/api/LegalDocuments/ViewLegalDocument?docType=${docType}&signedDate=${dateSigned}`,{responseType:"arraybuffer"})
}

export const signPDFDocumentAPI = (docType, payload) => {
    return Axios.post(`/api/LegalDocuments/SignLegalDocuments?doctype=${docType}`, payload)
}